<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div v-if="successfully_feedback === false">
      <div id="url_expired" style="text-align: center; width: 90%;">
        <h4>Welcome to Doodhvale, Please wait...</h4>
      </div>
      <div id="url_valid">
        <div id="border">
          <div style="text-align:center; margin-bottom: 10px;" id="milk_test_date">
            <h4 style="font-family:Calibari">Test Date</h4>
            <div class="display_test_date"><b style="font-family:Calibari">{{ convertDate(test_date) }}</b></div>
          </div>
          <div style="text-align:center; margin-bottom: 10px;" id="display_cow_milk_test_result">
            <h4><b style="font-family:Calibari">Cow Milk Test Result</b></h4>
          </div>
          <table class="table table-bordered">
            <col width="20">
            <col width="20">
            <thead>
              <tr class="usertable">
                <th scope="col">Tests</th>
                <th scope="col">Results</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>FAT<span class="graytext"> (3.5% to 3.9%)</span></td>
                <td>{{ cow_test.fat }} %</td>
              </tr>
              <tr>
                <td>SNF<span class="graytext"> (7.8 to 8.3)</span></td>
                <td>{{ cow_test.snf }} %</td>
              </tr>
              <tr>
                <td>Urea<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': cow_test.urea, 'positive': 1 }">0000</span><span
                    class="graytext"></span>
                  ({{ cow_test.urea ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
              <tr>
                <td>Starch<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': cow_test.starch, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ cow_test.starch ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
              <tr>
                <td>Detergent<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': cow_test.detergent, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ cow_test.detergent ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
              <tr>
                <td>Antibiotics<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': cow_test.antibiotic, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ cow_test.antibiotic ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
              <tr>
                <td>Acidity<span class="graytext"> (0.0%v/v - 68.0% v/v)</span></td>
                <td><span v-bind:class="{ 'negative': cow_test.alcohol, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ cow_test.alcohol ? "Not-Fresh" : "Fresh" }})</span></td>
              </tr>
              <tr>
                <td>Caustic Soda<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': cow_test.caustic, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ cow_test.caustic ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
            </tbody>
          </table>
          <div style="text-align:center; margin-bottom: 10px;" id="display_cow_milk_test_result">
            <h4><b style="font-family:Calibari">Buffalo Milk Test Result</b></h4>
          </div>
          <table class="table table-bordered">
            <col width="20">
            <col width="20">
            <thead>
              <tr class="usertable">
                <th scope="col">Tests</th>
                <th scope="col">Results</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>FAT<span class="graytext"> (6.2% to 6.7%)</span></td>
                <td>{{ buff_test.fat }} %</td>
              </tr>
              <tr>
                <td>SNF<span class="graytext"> (8.6 to 9.2)</span></td>
                <td>{{ buff_test.snf }} %</td>
              </tr>
              <tr>
                <td>Urea<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': buff_test.urea, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ buff_test.urea ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
              <tr>
                <td>Starch<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': buff_test.starch, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ buff_test.starch ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
              <tr>
                <td>Detergent<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': buff_test.detergent, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ buff_test.detergent ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
              <tr>
                <td>Antibiotics<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': buff_test.antibiotic, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ buff_test.antibiotic ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
              <tr>
                <td>Acidity<span class="graytext"> (0.0%v/v - 68.0% v/v)</span></td>
                <td><span v-bind:class="{ 'negative': buff_test.alcohol, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ buff_test.alcohol ? "Not-Fresh" : "Fresh" }})</span></td>
              </tr>
              <tr>
                <td>Caustic Soda<span class="graytext"> (0.0% to 0.5%)</span></td>
                <td><span v-bind:class="{ 'negative': buff_test.caustic, 'positive': 1 }">0000</span><span
                    class="graytext"> ({{ buff_test.caustic ? "Adultrated" : "Non-Adultrated" }})</span></td>
              </tr>
            </tbody>
          </table>
          <div class="para-color" id="test-discription">
            <p>
              Legends: Green - No adultration in milk. Red - Adultrated milk.
            </p>
            <h6 style="font-family:Calibari">Test Description:</h6>
            <p>
              1. FAT: The fat content of milk is the proportion of milk, by weight, made up by butterfat.
              Market processed milk FAT: Full Cream:6.2, Tonned:3.1, Double Tonned:1.5, Skimmed:.1
              Natural Healthy Cow Milk FAT varies between 3.4 to 4.0, Natural Healthy Buffalo Milk FAT varies between
              6.0 to 7.0
            </p>
            <p>
              2. SNF: Solid Not Fat, The substances in milk other than butterfat and water. They include casein,
              lactose, vitamins, and minerals which contribute significantly to the nutritive value of milk. Natural
              Healthy Cow Milk SNF varies between 7.5 to 8.5, Natural Healthy Buffalo Milk SNF varies between 8.5 to 9.5
            </p>
            <p>
              3. Urea: PASS {Green}: Milk is not adulterated with Urea. FAIL {Red}: Milk is adultrated with Urea.
            </p>
            <p>
              4. Starch: PASS {Green}: Milk is not adulterated with Starch. FAIL {Red}: Milk is adultrated with Starch.
            </p>
            <p>
              5. Detergent: PASS {Green}: Milk is not adulterated with Detergent. FAIL {Red}: Milk is adultrated with
              Detergent.
            </p>
            <p>
              6. Antibiotics: PASS {Green}: Milk is not adulterated with any antibiotics. FAIL {Red}: Milk is adultrated
              with antibiotics.
            </p>
            <p>
              7. Alcohol: Freshness & Acidity test of milk. PASS {Green}: Milk passes 68% v/v ethanol test. FAIL {Red}:
              Milk fails 68% v/v ethanol test.
            </p>
            <p>
              8. Caustic Soda: PASS {Green}: Milk is not adulterated with Castic Soda. FAIL {Red}: Milk is adultrated
              with Castic Soda.
            </p>
            <p>
              *Note: Minimum detection range: 0.5%
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'
import LTable from 'src/components/UIComponents/Table.vue'
import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
import axios from 'axios'
// import VueAxios from 'vue-axios'
export default {
  components: {
    Checkbox,
    Card,
    LTable,
    ChartCard,
    StatsCard
  },
  data () {
    return {
      urlInterface: [],
      obj: {},
      successfully_feedback: false,
      test_date: String,
      cow_test: {},
      buff_test: {},
      apiDataObj: [],
      isLoading: true,
      isFullPage: true
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      // console.log(process.env.BASE_API+ '/accounts/fetch-url-interface-data')
      const params = new URLSearchParams()
      var fullUrl = document.URL
      var splitUrl = fullUrl.split('dmtr?')
      params.append('url_str', splitUrl[1])
      // console.log(splitUrl[1])
      axios({
        url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params
      })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
            this.isLoading = false
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.urlInterface.sub_action_name = 'load'
            this.urlInterface.vue_url = fullUrl
            this.invokeUrlAction()
          }
          setTimeout(() => {
            this.isLoading = false
          }, 10000)
        })
        .catch(e => {
          this.isLoading = false
        })
    },

    invokeUrlAction () {
      const params = new URLSearchParams()
      params.append('url_interface_id', this.urlInterface.url_interface_id)
      params.append('action_name', this.urlInterface.action_name)
      params.append('sub_action_name', this.urlInterface.sub_action_name)
      axios({
        url: process.env.BASE_API + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
        .then(response => {
          this.apiDataObj = {}
          this.obj = response.data.action_response
          this.test_date = this.obj.test_date
          this.cow_test.fat = this.obj.cow_test_fat
          this.cow_test.snf = this.obj.cow_test_snf
          this.cow_test.clr = this.obj.cow_test_clr
          this.cow_test.urea = this.obj.cow_test_urea
          this.cow_test.starch = this.obj.cow_test_starch
          this.cow_test.detergent = this.obj.cow_test_detergent
          this.cow_test.caustic = this.obj.cow_test_caustic
          this.cow_test.antibiotic = this.obj.cow_test_antibiotic
          this.cow_test.alcohol = this.obj.cow_test_alcohol
          this.buff_test.snf = this.obj.buff_test_snf
          this.buff_test.clr = this.obj.buff_test_clr
          this.buff_test.fat = this.obj.buff_test_fat
          this.buff_test.urea = this.obj.buff_test_urea
          this.buff_test.starch = this.obj.buff_test_starch
          this.buff_test.detergent = this.obj.buff_test_detergent
          this.buff_test.caustic = this.obj.buff_test_caustic
          this.buff_test.antibiotic = this.obj.buff_test_antibiotic
          this.buff_test.alcohol = this.obj.buff_test_alcohol
          setTimeout(() => {
            this.isLoading = false
          }, 10000)
        })
        .catch(e => {
        })
    },
    convertDate: function (dateString) {
      var myday = new Date(dateString).getDay()
      var mydate = new Date(dateString).toDateString().split(' ')
      var weekday = new Array(7)
      weekday[0] = 'Sunday'
      weekday[1] = 'Monday'
      weekday[2] = 'Tuesday'
      weekday[3] = 'Wednesday'
      weekday[4] = 'Thursday'
      weekday[5] = 'Friday'
      weekday[6] = 'Saturday'
      return weekday[myday] + ' ' + mydate[2] + '-' + mydate[1] + '-' + mydate[3]
    }
  }
}
</script>
<style>
.loading-icon:before {
  content: "Wait...";
}

.loading-overlay .loading-icon:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #3CB6C3;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}

.inp {
  width: 170px;
  height: 40px;
}

#border {
  border: .01px solid black;
  padding: 15px;
  background: white !important;
  background-clip: border-box;
}

.table tbody tr:nth-child(2n) td {
  background-color: white !important;
}

.usertable th {
  color: black !important;
  font-weight: 800 !important;
  border: 1px solid #dee2e6 !important;
  background-color: white !important;
}

.positive {
  background-color: #4caf50;
  color: #4caf50;
}

.negative {
  background-color: #f44336;
  color: #f44336;
}

#test-discription p {
  text-align: left;
  color: #646464;
  font-family: Calibari;
}

.table>tbody>tr>th {
  background: white !important;
}

.table>tbody>tr>td>span.graytext {
  color: #646464;
  font-size: small;
  font-family: Calibari;
}

.table>tbody>tr>td {
  font-family: Calibari;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dmtr.vue